import styled from "styled-components";
export const SongSelectorContainer = styled.div`
  background-color: #FFFFFF;
`;